import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { BehaviorSubject, Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';
// import { Cart } from '../cart';
import { CartService } from '../cart.service';
import { CartItem } from '../cartItem';
import { Payment, Transaction } from '../payment';
import { PaymentService } from './payment.service';

@Injectable()
export class DealService {
   private startDeal: Deal = {
      dealCode: '',
      cartItems: [],
      transactions: [],
      cartWoTaxTotal: 0,
      cartTax8Total: 0,
      cartTax18Total: 0,
      cartTotal: 0,
      shipmentCost: 0,
      shipmentServiceCost: 0,
      giftDiscount: 0,
      cashierDiscount: 0,
      grandTax8: 0,
      grandTax18: 0,
      grandWoTax: 0,
      grandTotal: 0,
      totalTransactionValue: 0,
      remainingValue: 0,
      activeDiscount: 0,
      timestamp: new Date(Date.now()),
   };

   private dealSubject = new BehaviorSubject<Deal>(this.startDeal);
   activeDeal$: Observable<Deal> = this.dealSubject.asObservable();

   private fsResponseSubject = new BehaviorSubject<string>('wait');
   fsResponse$: Observable<string> = this.fsResponseSubject.asObservable();

   dealCodePrefix: string;

   constructor(
      // private cs: CartService,
      // private ps: PaymentService,
      private afs: AngularFirestore
   ) {}

   setWait() {
     console.log('sending WAIT signal');
     this.fsResponseSubject.next('wait');
   }

   setSuccess() {
    this.fsResponseSubject.next('success');
   }

   // logDeal(theCartObject: Cart, thePaymentObject: Payment) {
   //   const activeDeal = this.convertToDeal(theCartObject, thePaymentObject);
   //   console.log(activeDeal);
   // } 

   // convertToDeal(theCartObject: Cart, thePaymentObject: Payment): Deal {
   //  const shipmentCost = thePaymentObject.additions.filter(adt => adt.name === 'Kargo bedeli').reduce((sum, row) => sum = sum + row.amount, 0); 
   //  console.warn('thePaymentObject: ', thePaymentObject)
   //  const shipmentServiceCost = thePaymentObject.additions.filter(adt => adt.name === 'Kapıda ödeme').reduce((sum, row) => sum = sum + row.amount, 0);
   //  const giftDiscount = thePaymentObject.additions.filter(adt => adt.name === 'Hediye puanı').reduce((sum, row) => sum = sum + row.amount, 0);
   //  const cashierDiscount = thePaymentObject.additions.filter(adt => adt.name === 'Kasiyer indirimi').reduce((sum, row) => sum = sum + row.amount, 0);
   //  const grandTotal = theCartObject.cartTotal + shipmentCost + shipmentServiceCost - giftDiscount - cashierDiscount;
   //  const grandTax18 = theCartObject.cartTax18Total + (shipmentCost + shipmentServiceCost - giftDiscount - cashierDiscount) * 0.1525;

   //  const deal = {
   //    dealCode: this.addTimeCode(this.dealCodePrefix),
   //    cartItems: JSON.parse(JSON.stringify(theCartObject.cartItems)),
   //    // cartItems: theCartObject.cartItems,
   //    transactions: thePaymentObject.transactions,
   //    cartWoTaxTotal: theCartObject.cartPricesTotal,
   //    cartTax8Total: theCartObject.cartTax8Total,
   //    cartTax18Total: theCartObject.cartTax18Total,
   //    cartTotal: theCartObject.cartTotal,
   //    shipmentCost: shipmentCost,
   //    shipmentServiceCost: shipmentServiceCost,
   //    giftDiscount: giftDiscount,
   //    cashierDiscount: cashierDiscount,
   //    grandTax8: theCartObject.cartTax8Total,
   //    grandTax18: grandTax18,
   //    grandWoTax: grandTotal - grandTax18 - theCartObject.cartTax8Total,
   //    grandTotal: grandTotal,
   //    totalTransactionValue: thePaymentObject.totalTransactionValue,
   //    remainingValue: thePaymentObject.remainingValue,
   //    activeDiscount: thePaymentObject.activeDiscount,
   //    timestamp: new Date(Date.now()),
   //   };

   //   return deal;
   // }

   addCode(shopForm) {
      const storeCode = shopForm ? shopForm.shop : 'YY';
      const dealType = shopForm ? shopForm.operation : 'XX';
      // const saleSuffix = '000';

      return dealType + storeCode;
   }

    addTimeCode(prefix: string) {
      const now = new Date(Date.now());
      const timeCode =
         now.getFullYear().toString().slice(2) +
         (now.getMonth() + 1).toString().padStart(2, '0') +
         now.getDate().toString().padStart(2, '0') +
         now.getHours().toString().padStart(2, '0') +
         now.getMinutes().toString().padStart(2, '0');
      // const codePrefix = prefix.slice(0, 4);
      return prefix + timeCode;
   }

   changeDealCode(shopForm) {
            this.dealCodePrefix = this.addCode(shopForm);
            console.warn(this.dealCodePrefix);
   }

//    async saveDeal(theCartObject: Cart, thePaymentObject: Payment): Promise<any> {
//     const activeDeal = this.convertToDeal(theCartObject, thePaymentObject);
//     console.log(activeDeal);
//     console.log('now writing to FS');
//     try {
//        await this.afs.collection<Deal>('Deals').doc(activeDeal.dealCode).set(activeDeal);
//        return this.setSuccess();
//      } catch (e) {
//        return alert(e.message);
//      }

//     // console.warn('dealResponse: ', dealResponse);

//     // WAIT FOR THE ANSWER
//   } 


  

  
}

export interface Deal {
   dealCode: string;
   cartItems: CartItem[];
   transactions: Transaction[];
   cartWoTaxTotal: number;
   cartTax8Total: number;
   cartTax18Total: number;
   cartTotal: number;
   shipmentCost: number;
   shipmentServiceCost: number;
   giftDiscount: number;
   cashierDiscount: number;
   grandTax8: number;
   grandTax18: number;
   grandWoTax: number;
   grandTotal: number;
   totalTransactionValue: number;
   remainingValue: number;
   activeDiscount: number;
   timestamp: Date;
}
